module.exports = __webpack_public_path__ + "static/media/border-style-alt.8134ae1e.svg";